<template lang="pug">
  div
    //- エラーメッセージ
    b-alert.mx-2(v-model="showAlert", variant="warning")
      h5.error-msg.mb-0(v-for="(message, index) in errorMessages", :key="index")
        b-icon.mr-2(icon="exclamation-triangle-fill" variant="danger")
        | {{message}}
</template>

<script>
export default {
  name: 'AppMessagesWithIcon',
  props: {
    // エラーメッセージ
    errorMessages: { type: Array, default: () => [] }
  },
  computed: {
    /**
     * エラーメッセージを表示するかどうか
     */
    showAlert() {
      return this.errorMessages.length > 0
    }
  }
}
</script>
